import type { UserInfo } from "./authentication-service";

export class ExtendedUserInfo implements UserInfo {
    private _permissions: Set<string>;
    private _username: string;
    private _firstName: string | undefined;
    private _lastName: string | undefined;
    private _email: string | undefined;
    private _idEmpresaAgentes: string | null = null;
    private _idUsuario: string | null = null;
    private _grupoUsuario: string | null = null;
    private _idEstadoEmpresaAgentes: string | null = null;
    private _autoregistroEmpresaAgentes: boolean = false;

    constructor(username: string, firstName: string | undefined, lastName: string | undefined, email: string | undefined, permissions: string[], 
      idEmpresaAgentes: string | null = null, idUsuario: string | null = null, grupoUsuario: string | null = null,
      idEstadoEmpresaAgentes: string | null = null, autoregistroEmpresaAgentes: boolean = false) {
        this._permissions = new Set(permissions);
        this._username = username;
        this._firstName = firstName;
        this._lastName = lastName;
        this._email = email;
        this._permissions = new Set(permissions);
        this._idEmpresaAgentes = idEmpresaAgentes;
        this._idUsuario = idUsuario;
        this._grupoUsuario = grupoUsuario;
        this._idEstadoEmpresaAgentes = idEstadoEmpresaAgentes;
        this._autoregistroEmpresaAgentes = autoregistroEmpresaAgentes;
    }

    static toSerializable(instance: ExtendedUserInfo) {
        return {
            username: instance._username,
            firstName: instance._firstName,
            lastName: instance._lastName,
            email: instance._email,
            permissions: Array.from(instance._permissions),
            idEmpresaAgentes: instance._idEmpresaAgentes,
            idUsuario: instance._idUsuario,
            grupoUsuario: instance._grupoUsuario,
            idEstadoEmpresaAgentes: instance._idEstadoEmpresaAgentes,
            autoregistroEmpresaAgentes: instance._autoregistroEmpresaAgentes
        };
    }

    static fromSerializable(data: any) {
        if (data == null) {
            return null;
        }
        return new ExtendedUserInfo(data.username, data.firstName, data.lastName, data.email, data.permissions, data.idEmpresaAgentes, data.idUsuario, data.grupoUsuario, data.idEstadoEmpresaAgentes ?? null, data.autoregistroEmpresaAgentes ?? false);
    }

    get username() {
        return this._username;
    }

    get email() {
        return this._email;
    }

    get firstName() {
        return this._firstName;
    }

    get lastName() {
        return this._lastName;
    }

    get permissions() {
        return this._permissions;
    }

    get idEmpresaAgentes() {
        return this._idEmpresaAgentes;
    }

    get idUsuario() {
        return this._idUsuario;
    }

    get grupoUsuario() {
        return this._grupoUsuario;
    }

    get idEstadoEmpresaAgentes() {
        return this._idEstadoEmpresaAgentes;
    }

    get autoregistroEmpresaAgentes() {
        return this._autoregistroEmpresaAgentes;
    }
}
